import {
  SET_RECENT_LAUNCHED_GAME,
  SET_RECENT_SEARCHED_GAME,
  SET_VIEWED_CAMPAIGNS,
  SET_VIEWED_BONUSES_WELCOME,
} from '../../constants/storage';

export const setRecentLaunchedGame = (payload, userNumber: number) => ({
  type: SET_RECENT_LAUNCHED_GAME,
  payload,
  userNumber,
});
export const setRecentSearchedGame = (payload, userNumber: number) => ({
  type: SET_RECENT_SEARCHED_GAME,
  payload,
  userNumber,
});

// Campaigns
export const setViewedCampaigns = (payload, userNumber: number) => ({
  type: SET_VIEWED_CAMPAIGNS,
  payload,
  userNumber,
});

// Bonuses welcome message
export const setViewedBonusesWelcome = (userNumber: number) => ({
  type: SET_VIEWED_BONUSES_WELCOME,
  userNumber,
});
